import React, { useEffect, useState } from "react";
import routemappingbanner from "../../../main/assets/images/Images/Route Planning-Images/route-planning-banner.png";
import rpbannerM from "../../../main/assets/images/Images/Route Planning-Images/rp_banner_1.png";
import rp_graph2 from "../../../main/assets/images/Images/Route Planning-Images/rp_graph2.png";
import rp_graph3 from "../../../main/assets/images/Images/Route Planning-Images/rp_graph3.png";
import rp_graph4 from "../../../main/assets/images/Images/Route Planning-Images/rp_graph4.png";
import rp_graph5 from "../../../main/assets/images/Images/Route Planning-Images/rp_graph5.png";
import rp_graph_1 from "../../../main/assets/images/Images/Route Planning-Images/rp_graph_1.png";
import rp_graph_2 from "../../../main/assets/images/Images/Route Planning-Images/rp_graph_2.png";
import rp_graph_3 from "../../../main/assets/images/Images/Route Planning-Images/rp_graph_3.png";
import rp_graph_4 from "../../../main/assets/images/Images/Route Planning-Images/rp_graph_4.png";
import rp_graph_5 from "../../../main/assets/images/Images/Route Planning-Images/rp_graph_5.png";
import customersatifaction from "../../../main/assets/images/Icons/Route Planning-Icons/customer-satisfaction.svg";
import customersatifaction1 from "../../../main/assets/images/Icons/Route Planning-Icons/customer-satisfaction1.svg";
import fuelcost from "../../../main/assets/images/Icons/Route Planning-Icons/fuel-cost-efficiency.svg";
import fuelcost1 from "../../../main/assets/images/Icons/Route Planning-Icons/fuel-cost-white.svg";
import scenariotocost from "../../../main/assets/images/Icons/Route Planning-Icons/scenario-to-cost-analysis.svg";
import scenariotocost1 from "../../../main/assets/images/Icons/Route Planning-Icons/scenario-cost.svg";
import { Col } from "react-bootstrap";
import GraphDataOnLeft from "../../../main/components/componentsHelper/platformspage/GraphDataOnLeft";
import GraphDataOnRight from "../../../main/components/componentsHelper/platformspage/GraphDataOnRight";
import PlatformLearnMore from "main/components/componentsHelper/platformspage/PlatformLearnMore";
import { SectionCard } from "main/components";
import HeadingParagrap from "main/components/componentsHelper/platformspage/HeadingParagrap";
import { Button } from "main/components/ui-components/Button";
import { Link } from "react-router-dom";
import PlatformModulesBanner from "main/components/componentsHelper/platformspage/PlatformModulesBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import SectionCardMobile from "main/components/componentsHelper/whtyantrapage/SectionCardMobile";
type Props = {};

const RouteMapping = (props: Props) => {
  interface CARDDATA {
    path: string;
    whiteIcon: string;
    title: string;
    textmsg: string;
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [activetIndex, setActiveIndex] = useState(0);
  const goToSlide = (index: number) => {
    setActiveIndex(index);
  };
  const carddata: CARDDATA[] = [
    {
      path: scenariotocost,
      whiteIcon: scenariotocost1,
      title: "Scenario to Cost Analysis",
      textmsg:
        "Gain the most benefit from cost analysis report to maximize coverage ",
    },
    {
      path: fuelcost,
      whiteIcon: fuelcost1,
      title: "Fuel & Cost Efficiency",
      textmsg:
        "Drastically reduce fuel costs and wear-and-tear by following optimal routes.",
    },
    {
      path: customersatifaction,
      whiteIcon: customersatifaction1,
      title: "Customer Satisfaction",
      textmsg: "Ensure timely arrivals and keep your promises to customers.",
    },
  ];
  return (
    <div>
      <PlatformModulesBanner
        graphImage={rp_graph_1}
        MobilebgImage={rpbannerM}
        mobilepraphImage={rp_graph_1}
        descriptionClass="text-white-color fonts-400 font-20 mb-20 font-family-roboto plat-desc"
        HeaderClassName="text-white-color fonts-300 font-40 mb-10 font-family-condensed plat-header"
        heading="Route Planning"
        description="Planned navigations for field service technicians using Yantr.ai"
        backgroundImage={routemappingbanner}
        buttonGroup={
          <>
            <div className="d-block d-md-none">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                  className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo"
                />
              </Link>
            </div>
            <div className="d-none d-md-block">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                  className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo"
                />
              </Link>
            </div>
          </>
        }
      />
      <HeadingParagrap
        heading="Route Planning"
        headingpara="Our state-of-the-art AI ensures optimal routes, cutting costs, saving time, and increasing service efficiency. Let every route be the best route."
      />
      {/* website */}
      <div className="py-60 d-none d-md-block bg-color-n justify-content-center align-items-cente">
        <div className="d-flex text-white-color font-family-roboto font-30 flex-gap-20 fonts-800 line-35 pb-60 justify-content-center align-items-center garph-heading">
          Key Capabilities
        </div>
        <div className="d-flex flex-column flex-gap-30 container justify-content-center align-items-cente">
          <GraphDataOnLeft
            headingClass="text-black-10"
            path={rp_graph2}
            heading="AI-Driven Route Optimization"
            paragraph="Benefit from routes curated using advanced routing algorithms that consider heuristic model's real-time traffic data and constraints, ensuring minimal travel time and costs without impacting customer delivery."
          />
          <GraphDataOnRight
            headingClass="text-black-10"
            path={rp_graph3}
            heading="Complete Route Visibility"
            paragraph="Unlock insights into every journey. Optimize for efficiency, reduce costs, and elevate customer satisfaction by monitoring each route from start to finish."
          />

          <GraphDataOnLeft
            headingClass="text-black-10"
            path={rp_graph4}
            heading="Demand Planning"
            paragraph="Efficiently plan for shortage in vehicles with multiple service stops in a single trip, ensuring maximum coverage with minimum resources."
          />

          <GraphDataOnRight
            headingClass="text-black-10"
            path={rp_graph5}
            heading="EV Optimized Routes"
            paragraph="Minimize charging stops, extend battery life, and ensure efficient travel tailored to the unique requirements of electric vehicles."
          />
        </div>
      </div>
      {/* Mobile View */}
      <div className="d-block  d-md-none pb-30 bg-color-n justify-content-center align-items-cente">
        <div className="d-flex text-white-color font-family-roboto font-30 flex-gap-20 fonts-800 line-35 pt-40 pb-10 justify-content-center align-items-center garph-heading">
          Key Capabilities
        </div>
        <div className="d-flex flex-column flex-gap-20 py-30 container graphcontainer justify-content-center align-items-cente">
          <GraphDataOnLeft
            headingClass="text-black-10"
            path={rp_graph_2}
            heading="AI-Driven Route Optimization"
            paragraph="Benefit from routes curated using advanced routing algorithms that consider heuristic model's real-time traffic data and constraints, ensuring minimal travel time and costs without impacting customer delivery."
          />
          <GraphDataOnRight
            headingClass="text-black-10"
            path={rp_graph_3}
            heading="Complete Route Visibility"
            paragraph="Unlock insights into every journey. Optimize for efficiency, reduce costs, and elevate customer satisfaction by monitoring each route from start to finish."
          />

          <GraphDataOnLeft
            headingClass="text-black-10"
            path={rp_graph_4}
            heading="Demand Planning"
            paragraph="Efficiently plan for shortage in vehicles with multiple service stops in a single trip, ensuring maximum coverage with minimum resources."
          />

          <GraphDataOnRight
            headingClass="text-black-10"
            path={rp_graph_5}
            heading="EV Optimized Routes"
            paragraph="Minimize charging stops, extend battery life, and ensure efficient travel tailored to the unique requirements of electric vehicles."
          />
        </div>
      </div>
      {/* mobile */}
      <div className="d-block  d-md-none">
        <div className="container-fluid">
          <h2 className="dark-header font-30 font-family-roboto fonts-800 line-35 mt-4 d-flex justify-content-center align-items-center plat-header">
            Benefits
          </h2>
          <div className="row mx-1 mb-40 p-10">
            <Swiper
              slidesPerView={"auto"}
              spaceBetween={0}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              className="mySwiper customSwiper"
            >
              {carddata.map((val, index) => (
                <SwiperSlide className="p-10">
                  <div className="col-md-12 col-sm-12 col-lg-12 p-10">
                    <Col key={index}>
                      <SectionCardMobile
                        classname="cards"
                        title={val.title}
                        icon={val.path}
                        whiteIcon={val.whiteIcon}
                        desc={val.textmsg}
                      />
                    </Col>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
      {/* website */}
      <div className="d-none d-md-block pt-60 pb-30">
        <div className="container">
          <h2 className="dark-header font-30 font-family-roboto fonts-800 mb-20 line-35 d-flex justify-content-center align-items-center plat-header">
            Benefits
          </h2>
          <div className="row mx-1 p-10">
            {carddata.map((item, index) => (
              <div className="col-md-6 col-sm-6 col-lg-4 p-10">
                <div
                  className={`scard-container d-flex flex-column py-20 radius-10 justify-content-center align-items-center border border-1`}
                  key={index}
                >
                  <div className="image-container">
                    <img
                      className="sfront-image mx-5 my-3 mt-4"
                      src={item?.path}
                      alt="background will be here"
                    />
                    <img
                      className="sback-image mx-5 mb-2"
                      src={item?.whiteIcon}
                      alt="background will be here"
                    />
                  </div>
                  <div className="card-body">
                    <p
                      className={`d-flex justify-content-center text-center card-title px-5 fonts-600 font-family-roboto font-26 line-30 pb-2`}
                      style={{ color: "#3D1187" }}
                    >
                      {item?.title}
                    </p>
                    <p
                      className="px-3 tcard-desc text-center text-white-color fonts-400 font-16 line-20 font-family-roboto"
                      style={{ color: "#3D1187" }}
                    >
                      {item?.textmsg}
                    </p>
                  </div>
                </div>
                <div className="d-block d-md-none text-center">
                  <button
                    key={index}
                    className={
                      index === activetIndex
                        ? "active p-1"
                        : "banner-slider p-1"
                    }
                    onClick={() => goToSlide(index)}
                  ></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <PlatformLearnMore />
    </div>
  );
};

export default RouteMapping;
